define('shared/util/redirectionSignal',[
  '$',
  'Promise',
  'shared/page/market',
  'shared/page/language',
  'shared/util/path/ResolverFactory'
], function(
  $,
  Promise,
  getMarket,
  getLanguage,
  PathResolverFactory
) {

var ret = {
    RedirectionSignal: function (options) {
      this.url = options.url;
      this.sitePath = options.sitePath;
    },

    redirect: function (redirectionSignal) {
      return Promise.resolve()
        .then(function() {
          if (redirectionSignal.url) {
            return redirectionSignal.url;
          }
          return getSiteBasePath()
            .then(function(siteBase) {
              return siteBase + redirectionSignal.sitePath;
            });
        })
        .then(function(url) {
          window.location.href = url;
        });
    }
  }
  return ret;
});

